import { observer } from "mobx-react-lite"
import moment from "moment"
import { FC, useContext, useEffect, useState } from "react"
import { Context } from "../.."
import {StorageKey} from "../../constants"

const Snow: FC = () => {

  const { store } = useContext(Context)

  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const now = moment()

    console.log(now.month())

    if (now.month() >= 11 || now.month() < 2) {
      setVisible(true)
      store.setIsSnowVisible(true)
    } else {
      store.setIsSnow(false)
    }

    const isSn = localStorage.getItem(StorageKey.IS_SNOW)
    if (isSn != null && isSn == "false") {
      store.setIsSnow(false)
    }
  }, [])

  return (
    visible && store.isSnow ? <>
      <div id="snow_particles">
        {Array(60).fill("0").map(v => <div className="snow-p" style={{backgroundImage: "url(/assets/images/snowflake.png)"}}></div>)}
      </div>
    </> : <></>
  )
}

export default observer(Snow)